module.exports = __webpack_public_path__ + "img/sparkles.04f16c71.gif";